import { Box, MantineColor } from "@mantine/core";
import { i18n } from "@dehub/theme";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import type { TrustScoreLevel } from "../../apis/trust-score";
import { DotPill, Tone } from "../delivery/atoms";

export function trustLevelLabel (level?: TrustScoreLevel | string | null): string {
  if (!level) return "";
  return i18n.t(`returns:trustLevel.${level}`, { defaultValue: "-" });
}

/** Kept for callers that colour charts by level. */
export const TRUST_LEVEL_COLOR: Record<TrustScoreLevel, MantineColor> = {
  EXCELLENT: "teal",
  GOOD     : "green",
  MODERATE : "yellow",
  AT_RISK  : "orange",
  HIGH_RISK: "red",
};

/** Dot tone by level (canvas Ord_ReturnDetail «● Сайн»): good = green, moderate = amber, risk = red. */
export const TRUST_LEVEL_TONE: Record<TrustScoreLevel, Tone> = {
  EXCELLENT: "green",
  GOOD     : "green",
  MODERATE : "amber",
  AT_RISK  : "red",
  HIGH_RISK: "red",
};

interface Props {
  level: TrustScoreLevel;
  /** Kept for call-site compatibility; the dot pill has one size. */
  size?: "xs" | "sm" | "md" | "lg";
}

/** forwardRef so a Mantine Tooltip can wrap it. */
export const TrustLevelBadge = forwardRef<HTMLSpanElement, Props>(function TrustLevelBadge({ level }, ref) {
  const { t } = useTranslation("returns");
  return (
    <Box component="span" ref={ref} display="inline-flex">
      <DotPill tone={TRUST_LEVEL_TONE[level] ?? "grey"}>{t(`trustLevel.${level}`, { defaultValue: "-" })}</DotPill>
    </Box>
  );
});
